export default __webpack_public_path__ + "static/media/new_logo.644bb31e.png";